export const HIGH_STATUS_COLOR = 'high';
export const MEDIUM_STATUS_COLOR = 'medium';
export const NORMAL_STATUS_COLOR = 'normal';
